import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { CustomPaletteColor } from '../../theme';
import { ConvergeTooltip, PageTitle, StackLayout } from '../components';
import { PropsWithChildren, ReactNode } from 'react';

interface IProps extends PropsWithChildren {
  messageId: string;
  message: string;
  subtitleId?: string;
  subtitle?: string;
  icon?: ReactNode | boolean;
  color?: CustomPaletteColor;
  subtitleTooltip?: string;
  minHeight?: number | string;
}

export const ErrorPageLayout = ({
  messageId,
  message,
  icon,
  children,
  color,
  subtitle,
  subtitleId,
  subtitleTooltip,
  minHeight,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <StackLayout
      justifyContent="center"
      sx={{ flexGrow: 1, minHeight }}
      direction="column"
    >
      {icon === false
        ? null
        : icon ?? (
            <WarningIcon
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              color={(color as any) ?? CustomPaletteColor.Error}
              fontSize={'large'}
            />
          )}
      <PageTitle color={color ?? CustomPaletteColor.Error}>
        {t(messageId, message)}
      </PageTitle>
      {subtitle &&
        subtitleId &&
        (subtitleTooltip ? (
          <ConvergeTooltip title={subtitleTooltip}>
            <PageTitle variant="h6">{t(subtitleId, subtitle)}</PageTitle>
          </ConvergeTooltip>
        ) : (
          <PageTitle variant="h6">{t(subtitleId, subtitle)}</PageTitle>
        ))}
      {children}
    </StackLayout>
  );
};
